module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('f7-page', {
    attrs: {
      "name": "video-message"
    }
  }, [_c('bc-navbar'), _vm._v(" "), _c('div', {
    staticStyle: {
      "-webkit-touch-callout": "none",
      "height": "100%",
      "overflow-y": "auto",
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "loader",
    class: {
      none: !_vm.isRequestActive
    }
  }, [_c('looping-rhombuses-spinner', {
    attrs: {
      "animation-duration": 2500,
      "rhombus-size": 15,
      "color": "#f9f300"
    }
  })], 1), _vm._v(" "), _vm._l((_vm.videoMessages), function(vmessage, key) {
    return _c('div', {
      key: key,
      staticClass: "layout_fullwidth_padding",
      attrs: {
        "id": "focusDiv"
      },
      on: {
        "click": function($event) {
          return _vm.selectVideo(vmessage.videoMessageId)
        }
      }
    }, [_c('h3', [_vm._v("Video Messages")]), _vm._v(" "), (vmessage.youTubeId || vmessage.thumbnail) ? _c('div', {
      staticClass: "thumbnail-container"
    }, [_c('div', {
      staticClass: "play-button"
    }, [_c('img', {
      staticStyle: {
        "width": "25px",
        "height": "25px"
      },
      attrs: {
        "src": "/static/images/play_button.png"
      }
    })]), _vm._v(" "), (vmessage.youTubeId) ? _c('img', {
      attrs: {
        "src": 'https://img.youtube.com/vi/' + vmessage.youTubeId + '/0.jpg'
      }
    }) : _vm._e(), _vm._v(" "), (vmessage.url && !vmessage.youTubeId) ? _c('img', {
      attrs: {
        "src": vmessage.thumbnail
      }
    }) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "video_message_title",
      style: ({
        'background-color': _vm.customization.mainColor
      })
    }, [_c('h5', {
      style: ({
        'color': _vm.customization.fontColor
      })
    }, [_vm._v(_vm._s(vmessage.title))]), _vm._v(" "), _c('h6', {
      style: ({
        'color': _vm.customization.fontColor
      })
    }, [_vm._v("Sent On " + _vm._s(_vm.getDateAndTime(vmessage.sentDate)))])])])
  })], 2)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-9db67808", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9db67808"}!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/src/pages/video-message/video-message.vue
// module id = 806
// module chunks = 0